import { Fit } from "@seneca/image-service-client";

import { getDimensionFromCSSVar } from "seneca-common/utils/functions";

import type { ModuleDeviceRequirements } from "features/module/types";

import DIMENSIONS from "./components/exports.module.scss";

export const assetParameters = {
  default: {
    width: getDimensionFromCSSVar(DIMENSIONS.defaultimagewidth),
    height: getDimensionFromCSSVar(DIMENSIONS.defaultimageheight),
    fit: Fit.COVER
  }
};

export const DEVICE_REQUIREMENTS: ModuleDeviceRequirements = {
  minModuleWidth: 300,
  desktopOnly: false
};
